import React from 'react';

import * as Yup from 'yup';
import { capitalize } from 'lodash';

import { ia } from 'lib/helpers/utility';
import { formatDate } from 'lib/helpers/dateUtils';

import TagsView from 'components/shared/Tags/components/View/TagsView';
import {
  FORM_OPTIONS,
  PROVIDER_OPTIONS,
  SERVICE_OPTIONS,
  TAG_APPOINTMENT_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';
import TableTippy from '../components/TableTippy';

export const getCurrentStep = (breadcrumbs, currentBreadcrumb) => {
  // const hiddenSteps = breadcrumbs.filter((breadcrumb) => breadcrumb.hidden);
  let index = breadcrumbs.findIndex((breadcrumb) => breadcrumb.view === currentBreadcrumb);
  if (index >= 0) {
    index = index + 1;
  }
  return index;
};

export const getCurrentWithoutHidden = (breadcrumbs, currentBreadcrumb) => {
  const hiddenSteps = breadcrumbs.filter((breadcrumb) => !breadcrumb.hidden);
  let index = hiddenSteps.findIndex((breadcrumb) => breadcrumb.view === currentBreadcrumb);
  if (index >= 0) {
    index = index + 1;
  }
  return index;
};

export const getStepsLeft = (breadcrumbs, currentBreadcrumb) => {
  //get breadcrumbs which are not hidden
  const nonHiddenSteps = breadcrumbs.filter((breadcrumb) => !breadcrumb.hidden);
  const currentIndex = nonHiddenSteps.findIndex(
    (breadcrumb) => breadcrumb.view === currentBreadcrumb
  );

  if (currentIndex === -1) {
    return -1;
  }

  const remainingSteps = nonHiddenSteps.slice(currentIndex + 1);

  return remainingSteps.length;
};
export const getAllStepsLeft = (breadcrumbs, currentBreadcrumb) => {
  //get all breadcrumbs with hidden included
  const currentIndex = breadcrumbs.findIndex((breadcrumb) => breadcrumb.view === currentBreadcrumb);

  if (currentIndex === -1) {
    return -1;
  }

  const remainingSteps = breadcrumbs.slice(currentIndex + 1);

  return remainingSteps.length;
};

export const PacketInitialValues = (packet) => ({
  id: packet?.id || null,
  name: packet?.name || '',
  provider_ids: packet?.provider_ids || [],
  service_ids: packet?.service_ids || [],
  tag_ids: packet?.tag_ids || [],
  form_ids: packet?.form_ids || [],
  patient_creation: packet?.patient_creation || false,
  automation: {
    providers: ia(packet?.provider_ids) ? true : false,
    services: ia(packet?.service_ids) ? true : false,
    tags: ia(packet?.tag_ids) ? true : false,
    forms: ia(packet?.form_ids) ? true : false,
    patient_creation: packet?.patient_creation || false
  }
});

export const PacketValidationSchema = Yup.object().shape({
  name: Yup.string().required('Packet name is required')
});

export const defaultColumns = () => [
  {
    field: 'name',
    headerName: 'Name',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  {
    field: 'form_ids',
    headerName: 'Forms',
    cellClass: 'no-border',
    cellRenderer: ({ value }) => <TableTippy value={value} />
  },
  {
    field: 'service_ids',
    headerName: 'Services',
    cellClass: 'no-border',
    cellRenderer: ({ value }) => <TableTippy value={value} />
  },
  {
    field: 'provider_ids',
    headerName: 'Providers',
    cellClass: 'no-border',
    cellRenderer: ({ value }) => <TableTippy value={value} />
  },
  {
    field: 'tag_ids',
    headerName: 'Tags',
    cellClass: 'no-border',
    cellRenderer: ({ value }) => (
      <div className="flex h-full items-center">
        <TagsView
          currTags={value}
          kind="appointment"
          itemsToShow={2}
          label={false}
          appendTo={document.body}
        />
      </div>
    )
  },
  {
    field: 'status',
    headerName: 'Status',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? capitalize(value) : '-')
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value) : '-')
  },
  {
    field: 'updated_at',
    headerName: 'Updated on',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value) : '-')
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  search: {
    type: 'search',
    fields: [
      { field: 'id', label: 'ID' },
      { field: 'name', label: 'Name' }
    ]
  },
  name: {
    title: 'Packet name',
    placeholder: 'Search name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  forms: { ...FORM_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] },
  services: { ...SERVICE_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] },
  providers: { ...PROVIDER_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] },
  tags: { ...TAG_APPOINTMENT_OPTIONS, allowed_operators: ['is any of', 'is not', 'is'] }
};

export const removeAutomation = (packet) => {
  // eslint-disable-next-line no-unused-vars
  const { automation, ...rest } = packet;
  return rest;
};

export const removeAutomationAndEmptyValues = (packet) => {
  // eslint-disable-next-line no-unused-vars
  const { automation, ...data } = packet;
  Object.keys(data).forEach((key) => {
    if (ia(data[key])) {
      data[key] = data[key].filter((item) => item !== '' && item !== null);
    }
  });
  return data;
};

export const isArrayWithoutEmptyValues = (arr) => {
  if (!Array.isArray(arr)) {
    return false;
  }

  const nonEmptyValues = arr.filter((element) => element !== '');

  return nonEmptyValues.length > 0;
};
